import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-one-section',
  templateUrl: './explore-one-section.component.html',
  styleUrls: ['./explore-one-section.component.scss']
})
export class ExploreOneSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
